import { useMemo } from 'react';
import { createAdriverCustom } from '../../utils/helpers/createAdriverCustom';
import { useTargetedBanner } from '.';
import { TargetedBannerIds } from '../../types';

interface AdriverTargetingProps {
  leased?: boolean | string;
  rooms?: number;
  categoryId?: string;
  hasRepair?: boolean | string;
  cityName?: string;
  price?: number;
  hasBillOfSale?: boolean;
  hasMortgage?: boolean;
  shouldNotRunOnRouter?: boolean;
}

export const useAdriverTargeting = ({
  leased,
  rooms,
  categoryId,
  hasRepair,
  cityName,
  price,
  hasBillOfSale,
  hasMortgage,
  shouldNotRunOnRouter = false
}: AdriverTargetingProps) => {
  const adriverCustom = useMemo(() => {
    return createAdriverCustom({
      leased: typeof leased === 'boolean' ? leased.toString() : leased,
      rooms,
      categoryId,
      hasRepair:
        typeof hasRepair === 'boolean' ? hasRepair.toString() : hasRepair,
      cityName,
      price,
      hasBillOfSale,
      hasMortgage
    });
  }, [
    leased,
    rooms,
    categoryId,
    hasRepair,
    cityName,
    price,
    hasBillOfSale,
    hasMortgage
  ]);

  useTargetedBanner(TargetedBannerIds.bg, adriverCustom, shouldNotRunOnRouter);
  useTargetedBanner(
    TargetedBannerIds.catfish,
    adriverCustom,
    shouldNotRunOnRouter
  );
};
